<template>
  <div>
    <div class="mt-4 mx-4 mx-md-16">
      <div class="d-flex py-2">
        <v-icon class="ml-4 mr-2">mdi-magnify</v-icon>
        <v-text-field
          class="text-h5 font-weight-light"
          solo
          flat
          hide-details
          color="black"
          clearable
          v-model="searchText"
          @keydown.enter="search"
        >
        </v-text-field>
      </div>
      <v-divider class="my-4 mx-3"></v-divider>
    </div>
    <CarContainer :cars="this.cars" />
  </div>
</template>


<script>

import CarContainer from '../components/CarContainer.vue'

import {
  getFirestore,
  getDocs,
  query,
  collection,
  where
} from "firebase/firestore/lite";

export default {
  components: { CarContainer },

  data() {
    return {
      searchText: this.$route.query.q,
      cars: null
    };
  },

  watch: {
    '$route.query.q'() {
      this.getCars()
    }
  },

  mounted() {
    this.getCars();
  },

  methods: {
    async getCars() {
      const q = query(collection(getFirestore(), "cars"), 
        where('searchKeys', 'array-contains', this.$route.query.q.toLowerCase()));

      this.cars = (await getDocs(q)).docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    },

    search() {
      if (this.searchText == this.$route.query.q) { return }
      this.$router.push({name: 'search', query: { q: this.searchText }})
    },

    viewCar(id) {
      this.$router.push(`/car/${id}`)
    }
  },
};
</script>

